import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { delay, forkJoin, Observable, of, timeout } from 'rxjs';
import { DocumentSearchResult } from '../../../document/models/documentSearchResult';
import { DocumentLibraryConstants } from '../../../document/document-library-constants';
import { DocumentCommonService } from '../../../shared/services/document-common.service';
import { LinkedDocument } from '../../../shared/models/linked-documents';
import { cloneDeep } from 'lodash-es';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { CoursePersistenceService } from '../../services/course-persistence.service';
import { TrainingMaterial } from '../../models/training-material';
import { CourseConstants } from '../../constants/course.constants';
import { CourseService } from '../../services/course.service';
import { Attachment } from '../../../my-space/user-profile/models/attachment';
import { AssignmentGroupSharedDataService } from '../../../../app/shared/services/assignment-group-shared-data.service';
import { SharedConstants } from '../../../../app/shared/constants/shared-constants';

@Component({
  selector: 'app-course-training-material',
  templateUrl: './course-training-material.component.html',
  styleUrls: ['./course-training-material.component.scss']
})
export class CourseTrainingMaterialComponent implements OnInit{

  @Input() trainingMaterial:TrainingMaterial|undefined;
  @Output() activateTabIndex = new EventEmitter<number>();
  serviceData:TrainingMaterial|undefined;
  trainingMaterialForm!: FormGroup;
  savedFiles: string[] = [];
  files: File[] = [];
  addedFiles : string[]=[];
  deletedFiles: string[] = [];
  errorMessages: string[] = [];
  selectedDocuments: DocumentSearchResult[] = [];
  fileNamesForAddAndDeleteOperations: string[] = [];
  linkedDocuments: LinkedDocument[] = [];
  showRelatedDocumentsNotAlignedWithScopeConfirmationModal: boolean = false;
  showAddRelatedDocumentBtn: boolean = false;
  fileTypes = '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.png,.mp4';
  maxFileSize = CourseConstants.Attachment_File_Max_Size; 
  traingMaterialAttachments:Attachment[]=[];
  relatedDocumentsNotAlignedWithScopeConfirmationMessage: string =
    CourseConstants.RelatedDocuments_Not_Aligned_With_Scope_ConfirmationMessage;
    uploadedResponses : any = []
    documentNumbersNotAlignedWithParentDocument: string[] = [];
    showDocumentSearch: boolean = true;
    showFileUpload: boolean = true;
    isEditCourse : boolean = false;
    isInActiveAssignmentGroupDialog:boolean=false;
    InactiveAssignmentGroupField = '';
    inactiveUserSelected:any;
    inactiveGroupsSelected:any;
    courseTrainingMaterial : string = CourseConstants.CourseTrainingMaterialTab
 courseAttachmentMaxLimit= SharedConstants.AttachmentMaxLimit;

  constructor(private documentCommonService:DocumentCommonService,
    private confirmationService : ConfirmationService, 
    private router :Router,
    private formBuilder: FormBuilder,
    private coursePersistenceService: CoursePersistenceService,
    private courseService : CourseService,
  private messageService : MessageService,
  private assignmentGroupSharedDataService:AssignmentGroupSharedDataService){

  }
  ngOnInit(): void {
    this.resetToEmpty();
    this.trainingMaterialForm = this.createFormGroupModel();
    this.serviceData = this.trainingMaterial!;
    if(this.trainingMaterial!==null || this.trainingMaterial!==undefined){
    
      this.coursePersistenceService.currentTabInSliderMenu$.subscribe(
        (tabIndex) => {
          if (tabIndex === CourseConstants.Course_Create_Training_Material_Tab_Index) {
            this.updateFileDetailsOnTabChange();
          }
        });
    }
    this.coursePersistenceService.closeAndResetCourseSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetCourseSlider(); }});
      this.courseService.editCourseSlider$.subscribe((isEditCourse)=>{
        this.isEditCourse = isEditCourse;
        this.serviceData = this.trainingMaterial!;
        this.initializeData();
      })
        
  }

  initializeData(){
    this.trainingMaterialForm.patchValue({
      instructions : this.trainingMaterial?.instructions,
      urlLink:this.trainingMaterial?.urlLink,
      isURLVideo:this.trainingMaterial?.isURLVideo,
      attachments:this.trainingMaterial?.attachments,
      relatedDocuments:this.trainingMaterial?.relatedDocuments
    });
    this.linkedDocuments = this.trainingMaterial?.relatedDocuments !== null ? this.trainingMaterial?.relatedDocuments! : [];
    this.calculateSavedFiles()
  }
  createFormGroupModel(){
    return this.formBuilder.group({
      instructions:new FormControl(),
      urlLink:new FormControl(),
      isURLVideo:new FormControl(),
      attachments:new FormControl(),
      relatedDocuments:new FormControl()
    })
  }

  calculateSavedFiles = () => {
    if(this.trainingMaterial?.attachments !== null 
      && this.trainingMaterial?.attachments !== undefined 
      && this.trainingMaterial.attachments.length > 0){
        this.trainingMaterial?.attachments.forEach(
          (attachment: { attachmentName: string; }) => {
            this.savedFiles.push(attachment.attachmentName);
            this.fileNamesForAddAndDeleteOperations.push(attachment.attachmentName);
          }
        );
    }
  };

  closeAndResetCourseSlider(){
    this.trainingMaterialForm.reset();
    this.resetToEmpty();
  }

  resetToEmpty(){
    this.showDocumentSearch = false;
    this.showFileUpload = false;
  this.serviceData = undefined;
  this.savedFiles = [];
  this.files = [];
  this.errorMessages = [];
  this.selectedDocuments = [];
  this.fileNamesForAddAndDeleteOperations = [];
  this.linkedDocuments = [];
  this.traingMaterialAttachments = [];
  this.documentNumbersNotAlignedWithParentDocument = [];
  this.addedFiles = [];
  this.deletedFiles = [];
  this.coursePersistenceService.updateDeletedAttachments([]);
  this.showDocumentSearch = true;
  this.showFileUpload = true;
  }

  //ToDo : use the shared component
  openDeleteConfirmationModal = (documentNumber: string) => {
    this.confirmationService.confirm({
      header: DocumentLibraryConstants.Document_Slider_Confirmation_Header,
      message: DocumentLibraryConstants.RelatedDocuments_Delete_ConfirmationMessage,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.deleteRelatedDocument(documentNumber);
      },
    });

  }

  deleteRelatedDocument = (documentNumber: string) => {
    this.linkedDocuments = this.linkedDocuments!.filter((document) => { return document.number !== documentNumber });
  }
  

  uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
    this.files = [...this.files, ...uploadedFiles];
    uploadedFiles.forEach((file) => {
      this.fileNamesForAddAndDeleteOperations.push(file.name);
      this.addedFiles.push(file.name);
    });
    this.coursePersistenceService.updateTrainingMaterialAttachmentFiles(this.files);
    const fileNames = uploadedFiles.map((i) => i.name);
    return of(fileNames).pipe(delay(3000));
  };

  deleteFile = (fileName: string): Observable<boolean> => {
    this.deletedFiles.push(fileName);
    this.deleteAttachment(fileName);
    return of(true);
  };

  addRelatedDocuments = () => {
    this.validateRelatedDocumentsLinking();
  }

  onSelectionOrDeselection = (documents: DocumentSearchResult[]) => {
    this.selectedDocuments = [];
    this.selectedDocuments = cloneDeep(documents);
  }

  showOrHideAddRelatedDocumentButton = (displayAddRelatedDocumentBtn: boolean) => {
    this.showAddRelatedDocumentBtn = displayAddRelatedDocumentBtn;
  }

  validateRelatedDocumentsLinking = () => {
    this.errorMessages = [];
    this.validateIsDocumentLinked();
    if (this.errorMessages.length == 0) {
      this.validateeQMSScope();
    } else {
      document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  }

  validateeQMSScope = () => {
    let courseeQMSScopeList: number[] | undefined = [];
    courseeQMSScopeList = this.coursePersistenceService.courseDetails$.getValue()?.eqmsScopes
    let selectedDocumentsWithoutSharedScope: string[] = [];
    let iseQMSScopeShared = false;
    this.selectedDocuments.forEach((document: { eQMSScope: number[]; documentNumber: string; }) => {
      iseQMSScopeShared = false;
      if (!!document.eQMSScope) {
        document.eQMSScope.forEach((eQMSScope: number) => {
          if (courseeQMSScopeList!.indexOf(eQMSScope) > -1
            && !iseQMSScopeShared) {
            iseQMSScopeShared = true;
          };
        });
        if (!iseQMSScopeShared) {
          selectedDocumentsWithoutSharedScope.push(document.documentNumber);
        }
      } else {
        selectedDocumentsWithoutSharedScope.push(document.documentNumber);
      }
    });
    if (selectedDocumentsWithoutSharedScope.length > 0) {
      this.documentNumbersNotAlignedWithParentDocument = selectedDocumentsWithoutSharedScope;
      this.showRelatedDocumentsNotAlignedWithScopeConfirmationModal = true;
    } else {
      this.updateRelatedDocumentList();
    }
  }
  validateIsDocumentLinked = () => {
    if(this.linkedDocuments === undefined || this.linkedDocuments === null){
      this.linkedDocuments = [];
    }
    let relatedDocumentNumbers: string[] =  this.linkedDocuments!.map((document) => document.number);
    let alreadyLinkedDocuments = this.selectedDocuments.filter(document => relatedDocumentNumbers.indexOf(document.documentNumber) !== -1);
    if (alreadyLinkedDocuments.length > 0) {
      let documentNumbers = this.selectedDocuments.map((document) => document.documentNumber).join(", ");
      let errorMessageForAlreadyLinkedDocuments: string = alreadyLinkedDocuments.length === 1 ?
        DocumentLibraryConstants.RelatedDocuments_Already_Linked_With_Single_DocumentNumber_ErrorMessage.replace("Document_Number", documentNumbers) :
        DocumentLibraryConstants.RelatedDocuments_Already_Linked_With_Multi_DocumentNumbers_ErrorMessage.replace("Document_Numbers", documentNumbers)
      this.errorMessages.push(errorMessageForAlreadyLinkedDocuments);
    }
  }

  updateRelatedDocumentList = () => {
    this.getEffectiveOrLatestVersionOfSelectedDocuments();
    this.closeRelatedDocumentsNotAlignedWithScopeConfirmationModal();
  }

  getEffectiveOrLatestVersionOfSelectedDocuments = () => {
    let selectedDocumentNumbers: string[] = this.selectedDocuments.map((document) => document.documentNumber);
    this.documentCommonService.getEffectiveOrLatestVersionOfDocuments(selectedDocumentNumbers)
      .subscribe((linkedDocuments: LinkedDocument[]) => {
        this.linkedDocuments = [...this.linkedDocuments!, ...linkedDocuments];
      });
  }

  closeRelatedDocumentsNotAlignedWithScopeConfirmationModal = () => {
    this.showRelatedDocumentsNotAlignedWithScopeConfirmationModal = false;
  }

  loadDocumentDetails = (documentNumber: string, version: number) => {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/eqms.documentDetails/' + documentNumber + ':' + version,
      ])
    );
    window.open(url, '_blank');
  };

  trackByDocumentNumber = (index: number, document: LinkedDocument) => {
    return document.number;
  }

  openPreviousTab = () => {

    // Update Training Material Tab Details on click of Previous button
    this.updateFileDetailsOnTabChange();

    this.activateTabIndex.emit(
        CourseConstants.Course_Prerequisites_Index
    );
    this.coursePersistenceService.onCustomTabChange(
      CourseConstants.Course_Prerequisites_Index
    );
  };

  updateFileDetailsOnTabChange(){
      this.preAddedAttachments();
      this.mapTrainingMaterialToCourseTrainingMaterial();
  }

  saveCourse(){
    this.verifyIfCourseContainsInActiveAGForUpdate(this.coursePersistenceService.courseDetails$);
  }


  verifyIfCourseContainsInActiveAGForUpdate(courseDetailsInfo:any){
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(courseDetailsInfo.value,this.coursePersistenceService.validatedUsersList,
      this.coursePersistenceService.usersList
    );
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
    else {
      this.saveDocumentwithInactiveAssignmentGroup();
    }
}

  saveDocumentwithInactiveAssignmentGroup(){
    this.isInActiveAssignmentGroupDialog = false;
      this.preAddedAttachments();
      this.mapTrainingMaterialToCourseTrainingMaterial();
      this.updateCourseCall();  
  }
  
  closeConfirmationDailog(value : boolean){    
    this.isInActiveAssignmentGroupDialog = value
  } 


  private updateCourseCall(){
    this.courseService.editCourseSlider$.subscribe((isEditCourse)=>{
      if(!isEditCourse) this.coursePersistenceService.saveCourse(isEditCourse);
      else this.coursePersistenceService.updateCourse(isEditCourse);
    }); 
  }

  private mapTrainingMaterialToCourseTrainingMaterial(){
    let trainingMaterials:TrainingMaterial = {
      instructions:this.trainingMaterialForm.controls['instructions'].getRawValue(),
      urlLink:this.trainingMaterialForm.controls['urlLink'].getRawValue(),
      isURLVideo:this.trainingMaterialForm.controls['isURLVideo'].getRawValue(),
      relatedDocuments:this.linkedDocuments
    };
    trainingMaterials.attachments = this.traingMaterialAttachments;
    this.coursePersistenceService.updateTrainingMaterialDetails(trainingMaterials);
  }

  private deleteAttachment = (fileNameToDelete: string) => {
    this.files = this.files.filter((file) => {
      return file.name != fileNameToDelete;
    });
    this.fileNamesForAddAndDeleteOperations =
      this.fileNamesForAddAndDeleteOperations.filter((fileName) => {
        return fileName != fileNameToDelete;
      });
  };


  prepareTrainingMaterial(){
    if (this.files.length !== 0) {
      // Construct Training Material Data for Update
      let trainingMaterials : TrainingMaterial = {
        instructions : this.trainingMaterialForm.controls['instructions'].getRawValue(),
        urlLink : this.trainingMaterialForm.controls['urlLink'].getRawValue(),
        isURLVideo : this.trainingMaterialForm.controls['isURLVideo'].getRawValue(),
        relatedDocuments : this.linkedDocuments
      };
    }
    this.preAddedAttachments();
  }

  constructCourseAttachment = (fileName : string, fileSaveResponse: any): any => {
    return {
    attachmentFileId: fileSaveResponse.fileId,
    attachmentName: fileName,
    attachmentType: fileSaveResponse.fileExtension,
    attachmentPath: fileSaveResponse.filePath
    }
  }

  preAddedAttachments(){
    if(this.serviceData !== null && this.serviceData !== undefined && 
      this.serviceData?.attachments !== null && this.serviceData?.attachments !== undefined && 
      this.serviceData?.attachments.length > 0){
        this.serviceData.attachments.forEach((attachment: Attachment) => {
          this.traingMaterialAttachments.push(attachment);
        });
    }

    if(this.deletedFiles !== null && this.deletedFiles !== undefined && this.deletedFiles.length > 0){
      let preAddedFiles = [...this.traingMaterialAttachments];
      this.deletedFiles.forEach(deletedFileName => {
        preAddedFiles = preAddedFiles.filter((file)=>{
          return file.attachmentName !== deletedFileName;
        })
      });
      this.traingMaterialAttachments = preAddedFiles;
    }
  }

  preAddedRelatedDocuments(){
    let allRelatedDocuments : LinkedDocument[]= [];
    if(this.serviceData !== null && this.serviceData?.relatedDocuments !== null){
      if(this.linkedDocuments !== undefined && this.linkedDocuments !== null){
        allRelatedDocuments = this.linkedDocuments;
      }
    }
  }

  ngOnDestroy = () => {
    this.courseService.editCourseSlider$.unsubscribe();
    this.coursePersistenceService.currentTabInSliderMenu$.unsubscribe();
   }
}

